"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function Create(_a) {
    var _b;
    var channel = _a.channel;
    var _c = storybook_1.Hooks.useModal(), Modal = _c[0], setModal = _c[1], closeModal = _c[2];
    var _d = ra_fetch_1.useApi('media').store('messages', {
        title: '',
        body: '',
        channel_id: channel.id,
        data: {
            link_href: process.env.NEXT_PUBLIC_STORYBOOK_SITE_URL + "/kanalen/" + channel.name,
            link_label: "Ga naar " + channel.label
        },
        image: channel.logo
    }), message = _d[0], setMessage = _d[1], submitMessage = _d[2];
    var subscribers = ra_fetch_1.useApi('media').show('subscribers.count', {
        channel_id: channel.id
    })[0];
    var subscribersText = ((_b = subscribers.data.count) !== null && _b !== void 0 ? _b : 0) + " " + (subscribers.data.count === 1 ? 'volger' : 'volgers');
    function onSubmit() {
        submitMessage().then(function (response) {
            if (!response.errors.length) {
                setModal({
                    content: function () { return react_1.default.createElement(storybook_1.Forms.Success, { title: "Je bericht is verzonden naar " + subscribersText, onClose: closeModal }); }
                });
            }
        });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Modal, null),
        react_1.default.createElement(storybook_1.Forms.Form, null,
            react_1.default.createElement(storybook_1.Layouts.Container, { type: 'sm', className: 'storybook-layouts-space' },
                react_1.default.createElement(storybook_1.Cards.Card, null,
                    react_1.default.createElement(storybook_1.Cards.Content, null,
                        react_1.default.createElement(storybook_1.Messages.Form, { message: message.data, setMessage: setMessage }),
                        react_1.default.createElement(storybook_1.Forms.Buttons, { loading: message.submitting, errors: message.errors, submit: onSubmit, title: "verstuur naar " + subscribersText })))))));
}
exports.default = Create;
